import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const PopoverSpotBig = ({
  content,
  children,
  isSelected,
  onCheckboxToggle,
  onClick,
}) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    // Function to handle clicks outside the popover
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };

    // Attach the event listener when the popover is visible
    if (isVisible) {
      document.addEventListener('click', handleClickOutside);
    }

    // Detach the event listener when the popover is hidden
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isVisible]);

  const handleClick = () => {
    setIsVisible((prev) => !prev);
    onClick && onClick(); // Call onClick function if provided
  };

  const handleCheckboxChange = (index) => {
    // Call the callback function to update the state in the parent component
    onCheckboxToggle(index);
  };

  return (
    <div style={{ position: 'relative', overflow: 'visible' }} ref={popoverRef}>
      <div onClick={handleClick}>{children}</div>
      {isVisible && (
        <div className="psb-dropdown">
          <ul className="psb-list">
            {content.map((item, index) => (
              <li key={index} className="psb-item">
                <span className="box-checkbox" style={{ flexShrink: 0 }}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={item.name}
                    name={item.name}
                    checked={item.visible}
                    onChange={() => handleCheckboxChange(index)}
                  />
                </span>
                <label className="psb-label"
                  htmlFor={item.name}
                >
                  {t(item.label)}
                </label>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PopoverSpotBig;
